import { render, staticRenderFns } from "./VAlignCenter.vue?vue&type=template&id=6b671c7a&scoped=true&"
var script = {}
import style0 from "./VAlignCenter.vue?vue&type=style&index=0&id=6b671c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b671c7a",
  null
  
)

export default component.exports